/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShopifyConfig } from "./ShopifyConfig";
import {
  ShopifyConfigFromJSON,
  ShopifyConfigFromJSONTyped,
  ShopifyConfigToJSON,
  ShopifyConfigToJSONTyped,
} from "./ShopifyConfig";
import type { MaskedCompanyIntegration } from "./MaskedCompanyIntegration";
import {
  MaskedCompanyIntegrationFromJSON,
  MaskedCompanyIntegrationFromJSONTyped,
  MaskedCompanyIntegrationToJSON,
  MaskedCompanyIntegrationToJSONTyped,
} from "./MaskedCompanyIntegration";

/**
 *
 * @export
 * @interface IntegrationShopify
 */
export interface IntegrationShopify {
  /**
   *
   * @type {MaskedCompanyIntegration}
   * @memberof IntegrationShopify
   */
  integration: MaskedCompanyIntegration;
  /**
   *
   * @type {ShopifyConfig}
   * @memberof IntegrationShopify
   */
  config: ShopifyConfig;
}

/**
 * Check if a given object implements the IntegrationShopify interface.
 */
export function instanceOfIntegrationShopify(
  value: object,
): value is IntegrationShopify {
  if (!("integration" in value) || value["integration"] === undefined)
    return false;
  if (!("config" in value) || value["config"] === undefined) return false;
  return true;
}

export function IntegrationShopifyFromJSON(json: any): IntegrationShopify {
  return IntegrationShopifyFromJSONTyped(json, false);
}

export function IntegrationShopifyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IntegrationShopify {
  if (json == null) {
    return json;
  }
  return {
    integration: MaskedCompanyIntegrationFromJSON(json["integration"]),
    config: ShopifyConfigFromJSON(json["config"]),
  };
}

export function IntegrationShopifyToJSON(json: any): IntegrationShopify {
  return IntegrationShopifyToJSONTyped(json, false);
}

export function IntegrationShopifyToJSONTyped(
  value?: IntegrationShopify | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integration: MaskedCompanyIntegrationToJSON(value["integration"]),
    config: ShopifyConfigToJSON(value["config"]),
  };
}
